import {ITransaction} from '../../interfaces/transaction.interface';
import {IDeaRecord, IDeaReportRecord, IReportPackagingDetail} from '../../interfaces/dea-record.interface';
import { ReportTimeTypeEnum } from '../../interfaces/ReportTimeTypeEnum';
import { IInventoryTotals } from '../../interfaces/IInventoryTotals';
import { ITransactionModel } from '../../interfaces/ITransactionModel';
import { INdcPurchaseRecord } from '../../interfaces/INdcPurchaseRecord.interface';
import { RunCurrentInventoryReportRequest } from 'src/app/reports/interfaces/run-current-inventory-report-request.interface';
import { ICurrentInventoryReportNdcModel } from 'src/app/reports/interfaces/current-inventory-report-ndc-model.interface';
import { ISohHistoryReportItem } from 'src/app/reports/components/soh-history-report/interfaces/soh-history-report-item.interface';

export class GetDeaRecords {
  static readonly type = '[Reports] get dea report records';
}

export class GetDeaReportRecords {
  static readonly type = '[Reports] get records for new dea report';
}

export class SignReport {
  static readonly type = '[Reports] sign report';

  constructor(public reportId: string, public base64SignerSignature: string, public signerPin: number, public base64WitnessSignature: string, public witnessPin: number, public ascending: boolean, public includeLocations: boolean) {}
}

export class CreateNewDeaReport {
  static readonly type = '[Reports] get id of a new report';

  constructor(public timeType: ReportTimeTypeEnum, public isBiennial: boolean, public title?: string, public isAllDrugsMode: boolean = false, public schedulesToInclude?: number[], public locations?: number[]) {}
}

export class GetCustomReportRecords {
  static readonly type = '[Reports] get filtered custom report records';

  constructor(public filters: any) {
  }
}

export class SaveNewReportData {
  static readonly type = '[Reports] save base information about new report';

  constructor(public data: any) {
  }
}

export class SetCustomReportRecords {
  static readonly type = '[Reports] set custom report records list, e.g. for sorting purposes';

  constructor(public records: ITransactionModel[]) {
  }
}

export class SetSimilarOnHandHistoryRecords {
  static readonly type = '[Reports] Set Similar On Hand History Records';

  constructor(public records: ISohHistoryReportItem[]) {
  }
}
export class SetCurrentInventoryReportRecords {
  static readonly type = '[Reports] set current inventory report records list, e.g. for sorting purposes';

  constructor(public records: ICurrentInventoryReportNdcModel[]) {
  }
}

export class SetDeaReportDetailsList {
  static readonly type = '[Reports] set DEA report records list, e.g. for sorting purposes';

  constructor(public records: IDeaReportRecord[]) {
  }
}

export class SaveDeaReportDetailsRecord {
  static readonly type = '[Reports] save DEA report record after full pkg / open pkg updates';

  constructor(
    public index: number,
    public record: IReportPackagingDetail
  ) {
  }
}

export class SetInventoryTotals {
  static readonly type = '[Reports] set inventory totals records list, e.g. for sorting purposes';

  constructor(public records: IInventoryTotals[]) {
  }
}

export class SetDeaRecordsList {
  static readonly type = '[Reports] set DEA report records list, e.g. for sorting purposes';

  constructor(public records: IDeaRecord[]) {
  }
}
export class GetReportById {
  static readonly type = '[Reports] get one report by id';

  constructor(public reportId: string) {
  }
}

export class RunCustomReport {
  static readonly type = '[Reports] run custom report';

  constructor(public reportData: any) {
  }
}

export class RunInventoryTotalsReport {
  static readonly type = '[Reports] run Inventory Totals report';

  constructor(public payload: any) {
  }
}

export class SaveCustomReportFormState {
  static readonly type = '[Reports] save custom report form state';

  constructor(public formData: any) {
  }
}

export class SaveCurrentInventoryReportFormState {
  static readonly type = '[Reports] save current inventory form state';

  constructor(public formData: any) {
  }
}

export class SaveInventoryTotalsFormState {
  static readonly type = '[Reports] save inventory totals report form state';

  constructor(public formData: any) {
  }
}

export class SaveNdcPurchaseReportControlsState {
  static readonly type = '[Reports] Save Ndc Purchase Report Controls State';

  constructor(public formData: any) {
  }
}

export class SaveSimilarOnHandHistoryReportControlsState {
  static readonly type = '[Reports] Save Similar OnHand History Report Controls State';

  constructor(public formData: any) {
  }
}

export class RunNdcPurchaseReport {
  static readonly type = '[Reports] Run Ndc Purchase Report';

  constructor(public reportData: any) {
  }
}

export class SetLoading {
  static readonly type = '[Reports] set loading var';

  constructor(public isLoading: boolean) {
  }
}

export class SetNdcPurchaseRecords {
  static readonly type = '[Reports] Set Ndc Purchase Records';

  constructor(public records: INdcPurchaseRecord[]) {
  }
}

export class RunCurrentInventoryReport {
  static readonly type = '[Reports] Run Current Inventory Report';

  constructor(public request: RunCurrentInventoryReportRequest) {
  }
}

export class RunSimilarOnHandHistoryReport {
  static readonly type = '[Reports] Run Similar On Hand History Report';

  constructor(public reportData: any) {
  }
}

